import { Modal } from '@opendoor/bricks/complex';
import { Box, Button, Flex, H3, Text } from '@opendoor/bricks/core';
import { space } from '@opendoor/bricks/theme/eero';
import { noop } from 'lodash';

import { SellerInputAddress } from 'src/store/sellerInput';

import addressVerifyMapStyles from '../../helpers/addressVerifyMapStyles';
import GoogleMapDisplay from '../common/GoogleMapDisplay';

const MAP_OPTIONS = {
  disableDoubleClickZoom: false,
  fullscreenControl: false,
  styles: addressVerifyMapStyles,
  draggable: true,
  zoomControl: true,
};

interface IModalProps {
  address: SellerInputAddress;
  isOpen: boolean;
  onRequestClose: () => void;
  goToManualAddressVerificationPage?: () => void;
}

const AddressModal = (props: IModalProps) => {
  const { isOpen, onRequestClose, address, goToManualAddressVerificationPage } = props;
  const center = { lat: address.lat, lng: address.lng };

  return (
    <Modal
      analyticsName="reception-fe-address-modal"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      hasPadding
      aria-labelledby="correct-address-label"
    >
      <Box mt="10" height="220px">
        <GoogleMapDisplay
          center={center}
          iconUrl="https://imgdrop.imgix.net/pin.svg"
          width="100%"
          height="220px"
          options={MAP_OPTIONS}
        />
      </Box>
      <Flex
        my={[space[3], space[7]]}
        flexDirection="column"
        alignItems="center"
        px={[space[2], space[6]]}
      >
        <H3 fontWeight="semibold" color="neutrals100" textAlign="center" mb={3}>
          {address.street}
          <br />
          {address.city}, {address.state} {address.postalCode}
        </H3>
        <Text my={2} id="correct-address-label">
          Is this the correct address?
        </Text>

        <Flex mt={10} mb={8} maxWidth="420px" width="100%" height="47px">
          <Box mr="3" width="50%">
            <Button
              variant="secondary"
              onClick={onRequestClose}
              aria-label="Close modal"
              analyticsName="address-modal-close"
            >
              Close
            </Button>
          </Box>
          <Box width="50%" id="fix-address">
            <Button
              variant="primary"
              /** TODO @growth Semantic buttons without onClick methods are a11y violations. See https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Adding-onClick-handlers-to-non-interactive-elements-such-as-%3Cdiv-/%3E-or-%3CBox-/%3E-not-started */
              onClick={goToManualAddressVerificationPage ?? noop}
              aria-label=""
              analyticsName="address-modal-fix-address"
            >
              Fix address
            </Button>
          </Box>
        </Flex>
        <Text my={8} fontSize="s00" maxWidth="420px" textAlign="center">
          Note: if you change your address, we’ll start you back at the beginning to check that all
          your home information is entered correctly.
        </Text>
      </Flex>
    </Modal>
  );
};

export default AddressModal;
